import React from 'react'
import { useFloating } from '@floating-ui/react-dom'

import View from './view.js'

export default function Logic(props) {
  let { refs, x, y } = useFloating({
    open: true,
  })

  return (
    <View
      {...props}
      contentRef={refs.setFloating}
      top={props?.top || y}
      left={x}
    />
  )
}
